import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'
import Features from '../lockupFeatures'

interface IProps extends IItemCard {
  term: string
}

const LockupKeyFeatures = ({ item, term }: IProps) => {
  const keyFeatures = get(item, 'key_features', [])
  const showKeyFeatures = !!keyFeatures && keyFeatures.length > 0

  if (!showKeyFeatures) {
    return null
  }

  return <Features term={term} keyFeatures={keyFeatures} />
}

export default LockupKeyFeatures
